import { Link } from 'react-router-dom'

function SubFooter() {
    return(
        <footer className='text-center items-center mt-10 h-14 bg-white flex justify-center border border-t-2'>
            <p className='font-sans'>Copyright <Link to='/' className='font-sans hover:text-amber-700'>Supun Nisala</Link></p>
        </footer>
    )
}

export default SubFooter;